<div class="p-fluid ng-main" [ngClass]="theme">
    <div [class.hidden]="!this.commonService.showLoader.value" class="np-loader">
        <p-progressSpinner strokeWidth="5"></p-progressSpinner>
    </div>
    <!-- <div [class.hidden]="!showLoader" class="np-loader">
        <p-progressSpinner strokeWidth="5"></p-progressSpinner>
        Loading...
    </div> -->
    <router-outlet></router-outlet>
</div>

